var modalFull;

$(document).ready(function () {
  if ($("#materiais-portfolio-page").length) {
    if (TELA_MOBILE) {
      replaceResponsiveImages(
        ".materiais--header-img-capa",
        "img_bg",
        "-mobile",
        true
      );

      replaceResponsiveImages(
        ".materiais--fechamento-imagem",
        "img_fechamento",
        "-mobile",
        true
      );

      replaceResponsiveImages(
        ".imagem-content-full",
        "img_content",
        "-mobile",
        false
      );

      replaceResponsiveImages(
        ".imagem-content-bg",
        "img_content",
        "-mobile",
        true
      );
    } else {
      modalFull = "#modalFullImg";
      configOpenFullImage();
    }
  }
});

function configOpenFullImage() {
  $(".open-full").each(function (index, value) {
    var pattern = "img_content";
    var sufx = "-full";
    var dds = $(this).css("background-image").split(pattern);

    var src = dds[0] + pattern + sufx + dds[1];
    src = src.replace('url("', "");
    src = src.replace('")', "");

    $(this).click(function () {
      openFullImage(src);
    });
  });
}

function openFullImage(src) {
  console.log(src);
  showMenu(false);
  $("#imagem-modal-src").attr("src", src);
  $(modalFull).css("opacity", 0);
  $(modalFull).addClass("modal-show");

  animeModal(1);
}

function closeFullImage() {
  animeModal(0, true);
}

function animeModal(op, remove) {
  anime({
    targets: modalFull,
    opacity: op,
    duration: 700,
    easing: "easeOutExpo",
    complete: function (anim) {
      if (remove) $(modalFull).removeClass("modal-show");
    },
  });
}

function overRotateCloseFull() {
  anime({
    targets: ".modal__bt-fechar-ico",
    rotate: 180,
    duration: 400,
    // easing: "easeInOutExpo",
    complete: function (anim) {
      $(".modal__bt-fechar-ico").css({ WebkitTransform: "rotate(0deg)" });
      $(".modal__bt-fechar-ico").css({ "-moz-transform": "rotate(0deg)" });
    },
  });
}
